import React from 'react';

import {
  useCheckForEmailInput,
  useDoubleTheDonationSetup,
} from '+/utils/hooks/useDoubleTheDonation';

const DoubleTheDonation = ({ controller }: { controller: EveryActionModelController }) => {
  const { doubleTheDonationExists, doubleTheDonationState } = useDoubleTheDonationSetup();
  useCheckForEmailInput(controller);

  return (
    <>
      {doubleTheDonationExists && (
        <span id="dd-label">
          {doubleTheDonationState?.doubleTheDonationCompanyId
            ? 'employer match found'
            : 'search for employer match'}
        </span>
      )}
      <div id="dd-company-name-input" />
    </>
  );
};

export default DoubleTheDonation;
